import React, { Component } from 'react'
import { globals } from "../Globals/Globals";
import { useDispatch, useSelector } from "react-redux";
import { loadToolboxPartners } from "../../redux/toolboxPartnerSlice";  
import DsScrollingCarousel from '../DsScrollingCarousel/DsScrollingCarousel';

const HomeToolboxPartnersCarousel = () => {
    const dispatch= useDispatch();
    const {toolboxPartnersItems, loadToolboxPartners_result} = useSelector((state) => state.toolbox)

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        // If status is !loading, then fetch the hotels data from the API
        if (loadToolboxPartners_result.status === 'idle'){
            if (globals.parameters.redux_debugging) alert("Loading Toolbox partners will start...")
            dispatch(loadToolboxPartners());
        }

        if (loadToolboxPartners_result.status === 'succeeded'){
          if (globals.parameters.redux_debugging) alert("...Toolbox partners successfully loaded")
        }
        // Cleanup function
        return () => {
        isMounted = false
        }
    }, [loadToolboxPartners_result, dispatch, toolboxPartnersItems]);

    return(
        <div id="home-partners-carousel">
            <DsScrollingCarousel
                pictures_list =  {toolboxPartnersItems}
                dom_image_class_containter = {"partners-image-container"}   
                dom_image_prefix = {"partners"}   
                picture_field_name = {"image"}
                title_field_name = {"partner"}
                pause_in_second = {5}
                fallback_picture = {globals.dico.partners_fallback_picture}
                pause = {false || globals.parameters.pause_carousel}
                show_all = {true}
                debugging={false}
            />
        </div>
        )
} 

export default HomeToolboxPartnersCarousel;